import React from 'react'
const Observatoiredisc = () => {
  return (
    <div className="">
      {/* Text Content */}
      <div className="  bg-transparent h-full grid justify-items-center items-center p-6 lg:p-24 gap-6 lg:gap-12">
        <p className="text-3xl lg:text-5xl font-semibold text-blue-800">
        Présentation du 
        </p>
        <p className="text-2xl lg:text-4xl gabriel uppercase text-blue-400">
        L'Observatoire 
        </p>
        <p className="text-lg lg:text-2xl text-gray-600 leading-relaxed">
        L'Observatoire des Écosystèmes Aquatiques (AQUASOL) a pour mission de contribuer à la conservation et à la restauration 
des écosystèmes aquatiques de la région de Nabeul, et plus particulièrement de la zone humide de Soliman. <br />Les solutions 
proposées par l'observatoire reposent sur les résultats issus de la recherche scientifique et du suivi sur le terrain réalisés par 
un ensemble d'experts, de chercheurs, et des membres de l'AEDS (Association pour l'Environnement et le Développement de 
Soliman). 
        </p>
      </div>
  
      {/* Image Background Section */}
      {/* <div className="relative col-start-8 col-end-13 img-bg-discover bg-cover bg-center h-96 lg:h-full">
        <div className="absolute inset-0 bg-blue-500 opacity-60"></div>
        <div className="relative z-10 p-4 h-full grid">
          <div className="h-full place-content-end">
            <h1 className="text-4xl lg:text-6xl font-semibold text-yellow-400">You are..</h1>
          </div>
          <div className="h-full place-content-center">
            <h2 className="text-4xl lg:text-6xl font-semibold text-white">
              An Enterprise <span className="text-yellow-400">?</span>
            </h2>
            <h2 className="text-4xl lg:text-6xl font-semibold text-white">
              A Researcher <span className="text-yellow-400">?</span>
            </h2>
          </div>
          <div className="h-full">
            <h1 className="text-3xl lg:text-5xl font-semibold text-yellow-400">Join our community!</h1>
          </div>
        </div>
      </div> */}
    </div>
  );
  
      
  
}


export default Observatoiredisc